module.exports = __webpack_public_path__ + "static/img/p3.bf55a70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/p3.png
// module id = 64
// module chunks = 1